export class RegistrationRevenue {
  public Id: string;
  public DisplayName: string;
  public EventId: number;
  public ProfileId: number;
  public AdjustedAmountPaid: number;
  public AdjustedInvoicedAmount: number;
  public HasInvoices: boolean;
  public HasPostedInvoices: boolean;
  public HasPayments: boolean;
  public HasPostedPayments: boolean;
  public HasInvoiceAdjustments: boolean;
  public HasPostedInvoiceAdjustments: boolean;
  public HasPaymentAdjustments: boolean;
  public HasPostedPaymentAdjustments: boolean;
  public HasCreditCardTransactions: boolean;
  public Invoices: Array<any>;
  public constructor() {
    this.Id = '';
    this.DisplayName = '';
    this.EventId = 0;
    this.ProfileId = 0;
    this.AdjustedAmountPaid = 0;
    this.AdjustedInvoicedAmount = 0;
    this.HasInvoices = false;
    this.HasPostedInvoices = false;
    this.HasPayments = false;
    this.HasPostedPayments = false;
    this.HasInvoiceAdjustments = false;
    this.HasPostedInvoiceAdjustments = false;
    this.HasPaymentAdjustments = false;
    this.HasPostedPaymentAdjustments = false;
    this.HasCreditCardTransactions = false;
    this.Invoices = new Array<any>();
  }
}
